export default "__VITE_ASSET__BrECQFkn__"